<template>

  <div class="gap-2 flex flex-col px-4">
    <!-- Main widget -->
    <StatsMonth/>
    <!--Tabs widget -->
    <div
        class="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm  dark:border-gray-700 sm:p-6 dark:bg-gray-800">
      <div class="w-full">
        <h3 class="text-base font-normal text-gray-500 dark:text-gray-400">New products</h3>
        <span class="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">2,340</span>
        <p class="flex items-center text-base font-normal text-gray-500 dark:text-gray-400">
            <span class="flex items-center mr-1.5 text-sm text-green-500 dark:text-green-400">
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                   aria-hidden="true">
                <path clip-rule="evenodd" fill-rule="evenodd"
                      d="M10 17a.75.75 0 01-.75-.75V5.612L5.29 9.77a.75.75 0 01-1.08-1.04l5.25-5.5a.75.75 0 011.08 0l5.25 5.5a.75.75 0 11-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0110 17z"></path>
              </svg>
              12.5%
            </span>
          Since last month
        </p>
      </div>
      <div class="w-full" id="new-products-chart"></div>
    </div>
    <div
        class="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm  dark:border-gray-700 sm:p-6 dark:bg-gray-800">
      <div class="w-full">
        <h3 class="text-base font-normal text-gray-500 dark:text-gray-400">Users</h3>
        <span class="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">2,340</span>
        <p class="flex items-center text-base font-normal text-gray-500 dark:text-gray-400">
            <span class="flex items-center mr-1.5 text-sm text-green-500 dark:text-green-400">
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                   aria-hidden="true">
                <path clip-rule="evenodd" fill-rule="evenodd"
                      d="M10 17a.75.75 0 01-.75-.75V5.612L5.29 9.77a.75.75 0 01-1.08-1.04l5.25-5.5a.75.75 0 011.08 0l5.25 5.5a.75.75 0 11-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0110 17z"></path>
              </svg>
              3,4%
            </span>
          Since last month
        </p>
      </div>
      <div class="w-full" id="chart_container"></div>
    </div>
    <div
        class="p-4 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 sm:p-6 dark:bg-gray-800">
      <div class="w-full">
        <div class="flex items-center mb-2">
          <div class="w-16 text-sm font-medium dark:text-white">50+</div>
          <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
            <div class="bg-primary-600 h-2.5 rounded-full dark:bg-primary-500" style="width: 18%"></div>
          </div>
        </div>
        <div class="flex items-center mb-2">
          <div class="w-16 text-sm font-medium dark:text-white">40+</div>
          <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
            <div class="bg-primary-600 h-2.5 rounded-full dark:bg-primary-500" style="width: 15%"></div>
          </div>
        </div>
        <div class="flex items-center mb-2">
          <div class="w-16 text-sm font-medium dark:text-white">30+</div>
          <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
            <div class="bg-primary-600 h-2.5 rounded-full dark:bg-primary-500" style="width: 60%"></div>
          </div>
        </div>
        <div class="flex items-center mb-2">
          <div class="w-16 text-sm font-medium dark:text-white">20+</div>
          <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
            <div class="bg-primary-600 h-2.5 rounded-full dark:bg-primary-500" style="width: 30%"></div>
          </div>
        </div>
      </div>
      <div id="traffic-channels-chart" class="w-full"></div>
    </div>
  </div>
</template>
<script setup>
import imgUrlSrc from '../../../../assets/images/image.jpeg'
import {onMounted, ref} from "vue";

let imgUrl = ref(imgUrlSrc);
import ApexCharts from 'apexcharts';
import StatsMonth from "./stats_month.vue";

onMounted(() => {

  if (document.getElementById('new-products-chart')) {
    const options = {
      colors: ['#1A56DB', '#FDBA8C'],
      series: [
        {
          name: 'Quantity',
          color: '#1A56DB',
          data: [
            {x: '01 Feb', y: 170},
            {x: '02 Feb', y: 180},
            {x: '03 Feb', y: 164},
            {x: '04 Feb', y: 145},
            {x: '05 Feb', y: 194},
            {x: '06 Feb', y: 170},
            {x: '07 Feb', y: 155},
          ]
        }
      ],
      chart: {
        type: 'bar',
        height: '140px',
        fontFamily: 'Inter, sans-serif',
        foreColor: '#4B5563',
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          columnWidth: '90%',
          borderRadius: 3
        }
      },
      tooltip: {
        shared: false,
        intersect: false,
        style: {
          fontSize: '14px',
          fontFamily: 'Inter, sans-serif'
        },
      },
      states: {
        hover: {
          filter: {
            type: 'darken',
            value: 1
          }
        }
      },
      stroke: {
        show: true,
        width: 5,
        colors: ['transparent']
      },
      grid: {
        show: false
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
      xaxis: {
        floating: false,
        labels: {
          show: false
        },
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
      },
      yaxis: {
        show: false
      },
      fill: {
        opacity: 1
      }
    };

    const chart = new ApexCharts(document.getElementById('new-products-chart'), options);
    chart.render();
  }

  if (document.getElementById('sales-by-category')) {
    const options = {
      colors: ['#1A56DB', '#FDBA8C'],
      series: [
        {
          name: 'Desktop PC',
          color: '#1A56DB',
          data: [
            {x: '01 Feb', y: 170},
            {x: '02 Feb', y: 180},
            {x: '03 Feb', y: 164},
            {x: '04 Feb', y: 145},
            {x: '05 Feb', y: 194},
            {x: '06 Feb', y: 170},
            {x: '07 Feb', y: 155},
          ]
        },
        {
          name: 'Phones',
          color: '#FDBA8C',
          data: [
            {x: '01 Feb', y: 120},
            {x: '02 Feb', y: 294},
            {x: '03 Feb', y: 167},
            {x: '04 Feb', y: 179},
            {x: '05 Feb', y: 245},
            {x: '06 Feb', y: 182},
            {x: '07 Feb', y: 143}
          ]
        },
        {
          name: 'Gaming/Console',
          color: '#17B0BD',
          data: [
            {x: '01 Feb', y: 220},
            {x: '02 Feb', y: 194},
            {x: '03 Feb', y: 217},
            {x: '04 Feb', y: 279},
            {x: '05 Feb', y: 215},
            {x: '06 Feb', y: 263},
            {x: '07 Feb', y: 183}
          ]
        }
      ],
      chart: {
        type: 'bar',
        height: '420px',
        fontFamily: 'Inter, sans-serif',
        foreColor: '#4B5563',
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          columnWidth: '90%',
          borderRadius: 3
        }
      },
      tooltip: {
        shared: true,
        intersect: false,
        style: {
          fontSize: '14px',
          fontFamily: 'Inter, sans-serif'
        },
      },
      states: {
        hover: {
          filter: {
            type: 'darken',
            value: 1
          }
        }
      },
      stroke: {
        show: true,
        width: 5,
        colors: ['transparent']
      },
      grid: {
        show: false
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
      xaxis: {
        floating: false,
        labels: {
          show: false
        },
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
      },
      yaxis: {
        show: false
      },
      fill: {
        opacity: 1
      }
    };

    const chart = new ApexCharts(document.getElementById('sales-by-category'), options);
    chart.render();
  }

  const getVisitorsChartOptions = () => {
    let visitorsChartColors = {}

    if (document.documentElement.classList.contains('dark')) {
      visitorsChartColors = {
        fillGradientShade: 'dark',
        fillGradientShadeIntensity: 0.45,
      };
    } else {
      visitorsChartColors = {
        fillGradientShade: 'light',
        fillGradientShadeIntensity: 1,
      }
    }

    return {
      series: [{
        name: 'Visitors',
        data: [500, 590, 600, 520, 610, 550, 600]
      }],
      labels: ['01 Feb', '02 Feb', '03 Feb', '04 Feb', '05 Feb', '06 Feb', '07 Feb'],
      chart: {
        type: 'area',
        height: '305px',
        fontFamily: 'Inter, sans-serif',
        sparkline: {
          enabled: true
        },
        toolbar: {
          show: false
        }
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: visitorsChartColors.fillGradientShade,
          shadeIntensity: visitorsChartColors.fillGradientShadeIntensity
        },
      },
      plotOptions: {
        area: {
          fillTo: 'end'
        }
      },
      theme: {
        monochrome: {
          enabled: true,
          color: '#1A56DB',
        }
      },
      tooltip: {
        style: {
          fontSize: '14px',
          fontFamily: 'Inter, sans-serif'
        },
      },
    }
  }


  const getSignupsChartOptions = () => {
    let signupsChartColors = {}

    if (document.documentElement.classList.contains('dark')) {
      signupsChartColors = {
        backgroundBarColors: ['#374151', '#374151', '#374151', '#374151', '#374151', '#374151', '#374151']
      };
    } else {
      signupsChartColors = {
        backgroundBarColors: ['#E5E7EB', '#E5E7EB', '#E5E7EB', '#E5E7EB', '#E5E7EB', '#E5E7EB', '#E5E7EB']
      };
    }

    return {
      series: [{
        name: 'Users',
        data: [1334, 2435, 1753, 1328, 1155, 1632, 1336]
      }],
      labels: ['01 Feb', '02 Feb', '03 Feb', '04 Feb', '05 Feb', '06 Feb', '07 Feb'],
      chart: {
        type: 'bar',
        height: '140px',
        foreColor: '#4B5563',
        fontFamily: 'Inter, sans-serif',
        toolbar: {
          show: false
        }
      },
      theme: {
        monochrome: {
          enabled: true,
          color: '#1A56DB'
        }
      },
      plotOptions: {
        bar: {
          columnWidth: '25%',
          borderRadius: 3,
          colors: {
            backgroundBarColors: signupsChartColors.backgroundBarColors,
            backgroundBarRadius: 3
          },
        },
        dataLabels: {
          hideOverflowingLabels: false
        }
      },
      xaxis: {
        floating: false,
        labels: {
          show: false
        },
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
      },
      tooltip: {
        shared: true,
        intersect: false,
        style: {
          fontSize: '14px',
          fontFamily: 'Inter, sans-serif'
        }
      },
      states: {
        hover: {
          filter: {
            type: 'darken',
            value: 0.8
          }
        }
      },
      fill: {
        opacity: 1
      },
      yaxis: {
        show: false
      },
      grid: {
        show: false
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
    };
  }

  if (document.getElementById('chart_container')) {
    const chart = new ApexCharts(document.getElementById('chart_container'), getSignupsChartOptions());
    chart.render();

    // init again when toggling dark mode
    document.addEventListener('dark-mode', function () {
      chart.updateOptions(getSignupsChartOptions());
    });
  }

  const getTrafficChannelsChartOptions = () => {

    let trafficChannelsChartColors = {}

    if (document.documentElement.classList.contains('dark')) {
      trafficChannelsChartColors = {
        strokeColor: '#1f2937'
      };
    } else {
      trafficChannelsChartColors = {
        strokeColor: '#ffffff'
      }
    }

    return {
      series: [70, 5, 25],
      labels: ['Desktop', 'Tablet', 'Phone'],
      colors: ['#16BDCA', '#FDBA8C', '#1A56DB'],
      chart: {
        type: 'donut',
        height: 400,
        fontFamily: 'Inter, sans-serif',
        toolbar: {
          show: false
        },
      },
      responsive: [{
        breakpoint: 430,
        options: {
          chart: {
            height: 300
          }
        }
      }],
      stroke: {
        colors: [trafficChannelsChartColors.strokeColor]
      },
      states: {
        hover: {
          filter: {
            type: 'darken',
            value: 0.9
          }
        }
      },
      tooltip: {
        shared: true,
        followCursor: false,
        fillSeriesColor: false,
        inverseOrder: true,
        style: {
          fontSize: '14px',
          fontFamily: 'Inter, sans-serif'
        },
        x: {
          show: true,
          formatter: function (_, {seriesIndex, w}) {
            const label = w.config.labels[seriesIndex];
            return label
          }
        },
        y: {
          formatter: function (value) {
            return value + '%';
          }
        }
      },
      grid: {
        show: false
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
    };
  }

  if (document.getElementById('traffic-by-device')) {
    const chart = new ApexCharts(document.getElementById('traffic-by-device'), getTrafficChannelsChartOptions());
    chart.render();

    // init again when toggling dark mode
    document.addEventListener('dark-mode', function () {
      chart.updateOptions(getTrafficChannelsChartOptions());
    });
  }
})
</script>